import { REJECTED_CROSSCUTTING_FAILED, REJECTED_CROSSCUTTING_REQUEST, REJECTED_CROSSCUTTING_SUCCESS } from "app/redux/actions/Factory/Crosscutting/RejectedCrosscuting/constant";


const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
      isError: false,
      message: null
  }
};

export const rejectedCrosscuttingReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
      case REJECTED_CROSSCUTTING_REQUEST:
          return {
              loading: true,
              totalPage: 0,
              data: [],
              error: {
                  isError: false,
                  message: null
              }
          }
      case REJECTED_CROSSCUTTING_SUCCESS:
          return {
              loading: false,
              data: action?.payload?.data,
              totalPage: action?.payload?.totalPage,
              error: {
                  isError: false,
                  message: null
              }
          }
      case REJECTED_CROSSCUTTING_FAILED:
          const { isError = true, message = "Something Went Wrong" } = action?.payload?.error || {}
          return {
              loading: false,
              totalPage: 0,
              data: [],
              error: {
                  isError: isError,
                  message: message
              }
          }
      default:
          return state;
  }
};